import { render, staticRenderFns } from "./CustomersLeadsTags.vue?vue&type=template&id=51dbb39d"
import script from "./CustomersLeadsTags.vue?vue&type=script&lang=js"
export * from "./CustomersLeadsTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports